import { enterpriseApiSlice } from "./index";
import { UsBankAccountInfo } from "../Model/paymentObjects";

export const achApi = enterpriseApiSlice.injectEndpoints({
  endpoints: (builder) => ({
    initAch: builder.mutation({
      query: () => ({
        url: "/stripe/ach/init",
        method: "POST",
      }),
      extraOptions: { auth: true },
      invalidatesTags: ["Ach"],
    }),
    fetchAch: builder.query({
      query: () => ({
        url: "/stripe/ach",
        method: "GET",
      }),
      extraOptions: { auth: true },
      providesTags: ["Ach"],
      transformResponse: (response) => new UsBankAccountInfo(response),
    }),
    deleteAch: builder.mutation({
      query: (id) => ({
        url: `/stripe/ach/${id}`,
        method: "DELETE",
      }),
      extraOptions: { auth: true },
      invalidatesTags: ["Ach"],
    }),
  }),
  overrideExisting: false,
});

export const {
  useInitAchMutation,
  useFetchAchQuery,
  useDeleteAchMutation,
} = achApi;

